<template>
  <nav aria-label="breadcrumb" class="site-breadcrumb">
    <ol class="breadcrumb">
      <li
        v-for="(crumb, index) in breadcrumbs"
        :key="index"
        class="breadcrumb-item"
        :class="{ active: index === breadcrumbs.length - 1 }"
      >
        <a v-if="index !== breadcrumbs.length - 1 && crumb.to" :href="crumb.to">{{ crumb.text }}</a>
        <span v-else>{{ crumb.text }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.site-breadcrumb {
  line-height: 1.4;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.breadcrumb-item {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #999;

  a {
    color: #888;
    text-decoration: none;

    &:hover {
      color: #257973;
      text-decoration: underline;
    }
  }

  &.active span {
    color: #666;
    font-weight: 500;
  }

  & + .breadcrumb-item::before {
    content: '/';
    margin: 0 8px;
    color: #ccc;
    font-weight: 400;
  }
}
</style>
